import { Field, Input } from '@chakra-ui/react'
import cn from 'clsx'
import { forwardRef } from 'react'

import Icon from '../icon/Icon'

interface ICustomInputProps {
	value: string
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
	iconName?: string
	fieldLabel?: string
	rootClassname?: string
	inputClassname?: string
	placeholder?: string
	disabled?: boolean
	error?: boolean
	errorMessage?: string
	onClear?: () => void
	maxLength?: number
	onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
}

const CustomInput = forwardRef<HTMLInputElement, ICustomInputProps>(
	(
		{
			value,
			onChange,
			onBlur,
			iconName,
			fieldLabel,
			rootClassname,
			inputClassname,
			placeholder,
			disabled,
			error,
			errorMessage,
			onClear,
			maxLength,
			onKeyDown
		},
		ref
	) => {
		const clearSearch = () => {
			onChange({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>)
			if (onClear) {
				onClear()
			}
		}
		return (
			<Field.Root className={rootClassname} invalid={error || !!errorMessage}>
				<div className='w-full'>
					{fieldLabel && (
						<Field.Label className='mb-2'>{fieldLabel}</Field.Label>
					)}
					<Input
						ref={ref}
						value={value}
						onChange={onChange}
						onBlur={onBlur}
						onKeyDown={onKeyDown}
						className={cn(
							'relative peer w-full rounded-[8px] pl-4 pr-12 h-[48px] border-2 bg-gray-100 focus:bg-white',
							error || errorMessage
								? 'border-[#DE1135]'
								: 'border-gray-100 focus:border-black',
							value && 'has-value',
							inputClassname
						)}
						placeholder={placeholder}
						disabled={disabled}
						maxLength={maxLength}
					/>

					{errorMessage && (
						<Field.ErrorText className='mt-1 rounded-[6px] bg-red-50 px-2 py-1 !text-[12px] leading-[16px] text-red-500'>
							{errorMessage}
						</Field.ErrorText>
					)}

					{value && !disabled && iconName && (
						<button
							type='button'
							className={cn(
								'absolute top-1/2 right-4',
								!fieldLabel && 'top-[25%]'
							)}
							onClick={clearSearch}
						>
							<Icon size={24} icon={iconName} />
						</button>
					)}
				</div>
			</Field.Root>
		)
	}
)

export default CustomInput

// This styles we can use for floating label. Just import floatingStyles from ./FloatingStyles
// and add it to Field.Label
// css={floatingStyles} style={{ background: 'none' }}
